import { LuSettings } from "react-icons/lu";
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleIcon from '@mui/icons-material/People';
import BookIcon from '@mui/icons-material/Book';
import { BrandingWatermark, Newspaper, SlideshowSharp } from "@mui/icons-material";
import QuizIcon from '@mui/icons-material/Quiz';
import EventIcon from '@mui/icons-material/Event';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const SidebarRoutes = [
    {
        title: "Customization Header",
        icon: <LuSettings className="mt-2 !text-xl" />,
        basePath: "customization",
        subRoutes: [
            { path: "main-header", label: "Main Header" },
            { path: "sub-header", label: "Sub Header" },
            { path: "sub-sub-header", label: "Sub Sub Header" }
        ]
    },
    {
        title: "Inventory",
        icon: <StorefrontIcon className="mt-2 !text-xl" />,
        basePath: "inventory",
        subRoutes: [
            { path: "products", label: "Products" },
        ]
    },


    {
        title: "Plan Management",
        icon: <BookIcon className="mt-2 !text-xl" />,
        basePath: "plan-management",
        subRoutes: [
            { path: "plantype", label: "Plan Type" },
            { path: "module", label: "Module" },
            { path: "plan", label: "Plan" }
        ]
    },

    {
        title: "Lead Management",
        icon: <PeopleIcon className="mt-2 !text-xl" />,
        basePath: "lead-management",
        subRoutes: [
            { path: "direct", label: "Direct Lead" },
            { path: "seller", label: "Seller Lead" },
            // { path: "module", label: "Module" },
            // { path: "plan", label: "Plan" }
        ]
    },

    {
        title: "Seller",
        icon: <PeopleIcon className="mt-2 !text-xl" />,
        basePath: "seller",
    },
    {
        title: "Blog",
        icon: <BookIcon className="mt-2 !text-xl" />,
        basePath: "blog",
        subRoutes: [
            { path: "category", label: "Category" },
            { path: "sub-category", label: "Sub Category" },
            { path: "", label: "All Blogs" }
        ]
    },

    {
        title: "Testimonial",
        icon: <BookIcon className="mt-2 !text-xl" />,
        basePath: "testimonial",

    },
    {
        title: "News",
        icon: <Newspaper className="mt-2 !text-xl" />,
        basePath: "news",
    },
    {
        title: "FAQ",
        icon: <QuizIcon className="mt-2 !text-xl" />,
        basePath: "faq",
    },
    {
        title: "Slider",
        icon: <SlideshowSharp className="mt-2 !text-xl" />,
        basePath: "slider",
    },
    {
        title: "Banner",
        icon: <BrandingWatermark className="mt-2 !text-xl" />,
        basePath: "banner",
    },

    {
        title: "Page Design",
        icon: <BrandingWatermark className="mt-2 !text-xl" />,
        basePath: "page-design",
    },
    {
        title: "Event",
        icon: <EventIcon className="mt-2 !text-xl" />,
        basePath: "event",
    },
    {
        title: "Meta",
        icon: <IoMdCheckmarkCircleOutline className="mt-2 !text-xl" />,
        basePath: "meta",
    },

    {
        title: "Customer",
        icon: <AssignmentTurnedInIcon className="mt-2 !text-xl" />,
        basePath: "customer-need",

        subRoutes: [
            { path: "", label: "Customer Need" },
            { path: "requirement", label: "Customer Requirement" },

        ]
    },


    {
        title: "Sell On LeadIndia",
        icon: <EventIcon className="mt-2 !text-xl" />,
        basePath: "sellonleadindia",
    },

    {
        title: "Trade Show",
        icon: <ShowChartIcon className="mt-2 !text-xl" />,
        basePath: "tradeshow",
    },

    {
        title: "Exhibition",
        icon: <ShowChartIcon className="mt-2 !text-xl" />,
        basePath: "exhibition",
    },


];

export default SidebarRoutes;